"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickQuery = quickQuery;
async function quickQuery(request) {
    const params = new URLSearchParams();
    params.set("query", request.query);
    if (request.kidsFriendlyOnly)
        params.set("kidsFriendlyOnly", "t");
    if (request.mobileFriendlyOnly)
        params.set("mobileFriendlyOnly", "t");
    return await fetch(`${this.baseUrl}/Search/QuickQuery?${params.toString()}`)
        .then(x => x.json())
        .then(x => x)
        .catch(() => ({ error: { code: "networkError", message: "A network error happened" } }));
}
//# sourceMappingURL=quickQuery.js.map